export interface CityFaq {
  question: string
  answer: string
}
export interface CityData {
  slug: string
  name: string
  /** Primary keyword phrase for the page, e.g. "Mobile Detailing Camarillo" */
  keyword: string
  title: string
  subtitle: string
  metaDescription: string
  /** 2-4 unique intro/body paragraphs about detailing in this city */
  paragraphs: string[]
  /** Local neighborhoods / nearby landmarks for local relevance */
  neighborhoods: string[]
  faqs: CityFaq[]
}
const PHONE = '(818) 381-9905'
export const cities: CityData[] = [
  {
    slug: 'camarillo',
    name: 'Camarillo',
    keyword: 'Mobile Detailing Camarillo',
    title: 'Mobile Car Detailing in Camarillo, CA',
    subtitle:
      'Premium mobile car detailing that comes to your driveway anywhere in Camarillo. No drop-off, no waiting rooms — just a showroom shine at your home or office.',
    metaDescription:
      "Top-rated mobile car detailing in Camarillo, CA. Mike's Pro Detail brings interior, exterior, and full car detailing to your home or office. Call (818) 381-9905.",
    paragraphs: [
      "Camarillo drivers know the toll the Southern California sun, coastal marine layer, and Highway 101 commute take on a vehicle. At Mike's Pro Detail, our mobile detailing service in Camarillo brings a fully equipped detail shop directly to your driveway, so you never have to drop your car off or wait in a lobby. From the neighborhoods around Mission Oaks to the homes near the Camarillo Premium Outlets, we deliver five-star results right where you live and work.",
      'Whether you drive a daily commuter, a weekend sports car, or a family SUV, our Camarillo car detailing packages are tailored to your vehicle and schedule. We bring our own water and detailing equipment, use premium eco-friendly products, and treat every car as if it were our own. We require access to a standard electrical outlet at the service location. Interior deep cleans, exterior hand washes, paint protection, and full bumper-to-bumper details are all available on-site.',
      'Because we are fully mobile, scheduling auto detailing in Camarillo is effortless — book a time that works for you and we handle the rest. Many of our Camarillo customers set up recurring maintenance details to keep their vehicles protected against the year-round sun and salt air that can fade paint and crack interiors.',
    ],
    neighborhoods: [
      'Mission Oaks',
      'Las Posas Estates',
      'Spanish Hills',
      'Old Town Camarillo',
      'Camarillo Heights',
    ],
    faqs: [
      {
        question: 'Do you offer mobile car detailing throughout Camarillo?',
        answer:
          "Yes. Mike's Pro Detail comes to any home, apartment, or office in Camarillo — including Mission Oaks, Spanish Hills, Camarillo Heights, and Old Town. We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location.",
      },
      {
        question: 'How much does car detailing in Camarillo cost?',
        answer:
          'Exterior details start at $160, interior details at $180, and our popular full detail at $300. SUV and truck pricing is slightly higher. Call (818) 381-9905 for an exact quote on your vehicle.',
      },
      {
        question: 'How long will the detail take at my Camarillo home?',
        answer:
          'A wash and wax takes about 1.5\u20132 hours, interior detailing 2\u20133 hours, and a full detail 3\u20134 hours. We never rush — quality results take proper time and attention.',
      },
      {
        question: 'Can you detail my car at my office in Camarillo?',
        answer:
          'Absolutely. Many Camarillo customers book details at their workplace near the Premium Outlets or business parks. We work quietly and cleanly while you stay productive.',
      },
    ],
  },
  {
    slug: 'oxnard',
    name: 'Oxnard',
    keyword: 'Car Detailing Oxnard',
    title: 'Mobile Car Detailing in Oxnard, CA',
    subtitle:
      'Mobile car detailing delivered to your door in Oxnard. Protect your vehicle from coastal salt air and sun with a premium detail that comes to you.',
    metaDescription:
      'Professional mobile car detailing in Oxnard, CA. Interior, exterior, and full detailing at your home or office. Beat the coastal salt air \u2014 call (818) 381-9905.',
    paragraphs: [
      "Living near the coast in Oxnard means your vehicle battles salt air, beach sand, and intense sun every single day. At Mike's Pro Detail, our mobile car detailing service in Oxnard removes corrosive salt and grime, restores deep gloss, and locks in protection that keeps your paint looking its best. We come to you anywhere in Oxnard — from the harbor and Channel Islands neighborhoods to the homes around RiverPark.",
      'Our Oxnard detailing packages cover everything from a quick maintenance wash and wax to a complete interior and exterior restoration. We use safe, scratch-free wash methods and premium sealants designed to stand up to coastal conditions, so your car stays protected long after we leave your driveway.',
      "As a fully mobile operation, we make professional auto detailing in Oxnard convenient and stress-free. There's no need to drive across town or wait at a shop — we bring our own water and detailing equipment, ready to deliver showroom results at your home or workplace. We require access to a standard electrical outlet at the service location.",
    ],
    neighborhoods: [
      'RiverPark',
      'Oxnard Shores',
      'Mandalay Bay',
      'Channel Islands Harbor',
      'Downtown Oxnard',
    ],
    faqs: [
      {
        question: 'Why is detailing important for cars in Oxnard?',
        answer:
          "Oxnard's coastal location exposes vehicles to salt air that accelerates corrosion and paint oxidation. Regular detailing with proper protection creates a barrier against salt, sand, and UV damage \u2014 preserving both your paint and resale value.",
      },
      {
        question: 'Do you come to homes near Oxnard Shores and the harbor?',
        answer:
          'Yes, we serve all of Oxnard including Oxnard Shores, Mandalay Bay, Channel Islands Harbor, RiverPark, and downtown. We bring everything needed to detail your vehicle on-site.',
      },
      {
        question: 'What does car detailing cost in Oxnard?',
        answer:
          'Pricing starts at $160 for exterior, $180 for interior, and $300 for a full detail, with slightly higher rates for larger vehicles. Call (818) 381-9905 for a personalized quote.',
      },
      {
        question: 'Can you remove salt and water spots from my paint?',
        answer:
          'Yes. Our decontamination, clay bar treatment, and paint protection steps are specifically effective at removing salt residue, water spots, and mineral etching common in coastal Oxnard.',
      },
    ],
  },
  {
    slug: 'ventura',
    name: 'Ventura',
    keyword: 'Auto Detailing Ventura',
    title: 'Mobile Car Detailing in Ventura, CA',
    subtitle:
      'Premium mobile auto detailing in Ventura that comes to you. Protect your investment from sun, sand, and surf with a detail delivered to your driveway.',
    metaDescription:
      'Expert mobile auto detailing in Ventura, CA. Interior deep cleans, exterior washes, and full details at your home or office. Call Mike\u2019s Pro Detail (818) 381-9905.',
    paragraphs: [
      "From the historic streets of downtown Ventura to the hillside homes overlooking the Pacific, Mike's Pro Detail brings professional auto detailing in Ventura directly to your location. Our fully mobile service means you skip the drop-off and the wait — we arrive with our own water, detailing equipment, and premium products to deliver a flawless detail wherever you park. We require access to a standard electrical outlet at the service location.",
      "Ventura's beach lifestyle is hard on vehicles: sand in the carpets, salt on the paint, and relentless sun fading interiors. Our Ventura detailing packages are built to combat exactly that, with deep interior extraction, leather conditioning, exterior decontamination, and durable paint protection that holds up to coastal conditions.",
      'Whether you need a one-time refresh before selling your car or a recurring maintenance plan to keep your daily driver pristine, our auto detailing in Ventura is tailored to your vehicle and schedule. We treat every car with meticulous attention and back our work with five-star service trusted across Ventura County.',
    ],
    neighborhoods: [
      'Downtown Ventura',
      'Ventura Keys',
      'Pierpont Beach',
      'Ondulando',
      'Midtown Ventura',
    ],
    faqs: [
      {
        question: 'Do you provide mobile auto detailing across Ventura?',
        answer:
          'Yes. We come to all Ventura neighborhoods including downtown, the Keys, Pierpont, Ondulando, and Midtown. We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location.',
      },
      {
        question: 'Can you get beach sand out of my carpets and seats?',
        answer:
          'Definitely. Our interior detail includes deep vacuuming, steam cleaning, and shampooing that removes embedded sand, salt, and stains from carpets, mats, and upholstery.',
      },
      {
        question: 'How much is auto detailing in Ventura?',
        answer:
          'Exterior details start at $160, interior at $180, and full details at $300, with adjustments for vehicle size and condition. Call (818) 381-9905 for an exact quote.',
      },
      {
        question: 'Do you offer recurring detailing in Ventura?',
        answer:
          'Yes, many Ventura customers book monthly or quarterly maintenance details to protect against the coastal sun and salt. We\u2019ll set up a schedule that fits your needs.',
      },
    ],
  },
  {
    slug: 'thousand-oaks',
    name: 'Thousand Oaks',
    keyword: 'Mobile Detailing Thousand Oaks',
    title: 'Mobile Car Detailing in Thousand Oaks, CA',
    subtitle:
      'Luxury mobile car detailing delivered to your home in Thousand Oaks. Showroom-quality results for your vehicle without ever leaving your driveway.',
    metaDescription:
      'Premium mobile detailing in Thousand Oaks, CA. Interior, exterior, full details, and ceramic protection at your door. Call Mike\u2019s Pro Detail (818) 381-9905.',
    paragraphs: [
      "Thousand Oaks is home to some of Ventura County's finest vehicles, and they deserve detailing to match. Mike's Pro Detail delivers luxury-grade mobile detailing throughout Thousand Oaks — from the gated communities of North Ranch to the family neighborhoods near The Oaks mall. We bring a complete detail shop to your driveway, so your car gets a meticulous, hand-crafted finish without you lifting a finger.",
      'Our Thousand Oaks detailing service is ideal for luxury and performance vehicles that demand careful, scratch-free care. We use premium products, safe wash techniques, and ceramic protection options to keep high-end finishes flawless. Interiors get the same attention, with leather conditioning, steam sanitizing, and trim restoration.',
      "Convenience is everything for busy Thousand Oaks professionals and families. Because we're fully mobile, you can keep working, relaxing, or running your day while we transform your vehicle on-site. We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location. Book a single detail or a recurring plan to keep your car in showroom condition year-round.",
    ],
    neighborhoods: [
      'North Ranch',
      'Lynn Ranch',
      'Wildwood',
      'Conejo Oaks',
      'Westlake (Thousand Oaks)',
    ],
    faqs: [
      {
        question: 'Do you detail luxury and exotic cars in Thousand Oaks?',
        answer:
          'Yes. We specialize in careful, scratch-free detailing for luxury, exotic, and performance vehicles throughout Thousand Oaks, including hybrid ceramic spray protection to add gloss and help high-end finishes shed water and dirt.',
      },
      {
        question: 'Which Thousand Oaks areas do you serve?',
        answer:
          'We come to all of Thousand Oaks including North Ranch, Lynn Ranch, Wildwood, Conejo Oaks, and surrounding neighborhoods. We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location.',
      },
      {
        question: 'What detailing packages are available in Thousand Oaks?',
        answer:
          'We offer exterior details from $160, interior details from $180, full details from $300, plus ceramic protection. Call (818) 381-9905 for a quote.',
      },
      {
        question: 'Can you come to gated communities in Thousand Oaks?',
        answer:
          'Yes \u2014 just let us know any gate or access details when booking and we\u2019ll coordinate entry so we can detail your vehicle right at your home.',
      },
    ],
  },
  {
    slug: 'simi-valley',
    name: 'Simi Valley',
    keyword: 'Mobile Detailing Simi Valley',
    title: 'Mobile Car Detailing in Simi Valley, CA',
    subtitle:
      'Mobile car detailing that comes to your home or job site in Simi Valley. Beat the heat and dust with a premium detail delivered to your driveway.',
    metaDescription:
      'Professional mobile detailing in Simi Valley, CA. Interior, exterior, and full car detailing at your home or office. Call Mike\u2019s Pro Detail at (818) 381-9905.',
    paragraphs: [
      "Simi Valley's hot, dry climate and frequent dust mean vehicles here need regular care to stay looking their best. Mike's Pro Detail brings mobile detailing directly to homes and businesses across Simi Valley — from the neighborhoods near Wood Ranch to the communities around Sycamore and Tapo Canyon. We arrive fully equipped, so your car gets a thorough, professional detail right in your driveway.",
      'Heat and sun are tough on paint and interiors, causing fading, cracking, and oxidation over time. Our Simi Valley detailing packages include UV-blocking interior protectants, durable exterior sealants, and deep cleaning that removes the fine dust and grime that builds up in this inland climate. We use safe, scratch-free methods and premium products on every vehicle.',
      "As a fully mobile service, we make auto detailing in Simi Valley simple. There's no drive across town and no waiting room — we bring our own water and detailing equipment and handle everything on-site while you go about your day. We require access to a standard electrical outlet at the service location. Choose a one-time detail or a maintenance plan to keep your vehicle protected against the valley heat.",
    ],
    neighborhoods: [
      'Wood Ranch',
      'Big Sky',
      'Texas Tract',
      'Sycamore',
      'Tapo Canyon',
    ],
    faqs: [
      {
        question: 'Do you offer mobile detailing throughout Simi Valley?',
        answer:
          'Yes. We serve all Simi Valley neighborhoods including Wood Ranch, Big Sky, the Texas Tract, Sycamore, and Tapo Canyon. We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location.',
      },
      {
        question: 'How do you protect my car from Simi Valley heat and sun?',
        answer:
          'We apply UV-blocking interior protectants to dashboards and trim and durable paint sealants or hybrid ceramic spray to the exterior, helping prevent fading, cracking, and oxidation from the intense inland sun.',
      },
      {
        question: 'What does detailing cost in Simi Valley?',
        answer:
          'Exterior details start at $160, interior at $180, and full details at $300, with slightly higher pricing for larger vehicles. Call (818) 381-9905 for an exact quote.',
      },
      {
        question: 'Can you detail multiple vehicles at one location?',
        answer:
          'Yes \u2014 we\u2019re happy to detail multiple cars at your Simi Valley home or business in one visit. Let us know how many vehicles when you book.',
      },
    ],
  },
  {
    slug: 'moorpark',
    name: 'Moorpark',
    keyword: 'Mobile Detailing Moorpark',
    title: 'Mobile Car Detailing in Moorpark, CA',
    subtitle:
      'Mobile car detailing delivered to your door in Moorpark. Premium interior and exterior detailing with no drop-off and no waiting.',
    metaDescription:
      'Trusted mobile detailing in Moorpark, CA. Interior, exterior, and full car detailing at your home or office. Call Mike\u2019s Pro Detail at (818) 381-9905.',
    paragraphs: [
      "Moorpark's mix of suburban neighborhoods, ranch properties, and a hardworking commuter lifestyle means vehicles here see plenty of dust, sun, and miles. Mike's Pro Detail brings professional mobile detailing directly to your Moorpark driveway — from the homes near Moorpark College to the communities around Campus Park and Mountain Meadows. We arrive ready to deliver a meticulous detail on-site.",
      'Our Moorpark detailing packages range from a maintenance wash and wax to a complete interior and exterior restoration. We remove the fine inland dust, road grime, and sun damage that accumulate over time, then protect your vehicle with premium sealants and interior protectants. Every car receives safe, scratch-free care and genuine attention to detail.',
      "Because we're fully mobile, scheduling auto detailing in Moorpark is effortless. We come to your home or workplace with our own water and detailing equipment, so you save time and skip the trip to a shop. We require access to a standard electrical outlet at the service location. Book a single detail or set up a recurring plan to keep your vehicle looking its best year-round.",
    ],
    neighborhoods: [
      'Campus Park',
      'Mountain Meadows',
      'Varsity Park',
      'Peach Hill',
      'Home Acres',
    ],
    faqs: [
      {
        question: 'Do you come to all areas of Moorpark?',
        answer:
          'Yes. We serve every Moorpark neighborhood including Campus Park, Mountain Meadows, Varsity Park, Peach Hill, and Home Acres. Our mobile unit brings everything needed to detail your car at home or work.',
      },
      {
        question: 'What detailing services do you offer in Moorpark?',
        answer:
          'We provide interior detailing, exterior detailing, full details, headlight restoration, and ceramic protection \u2014 all delivered to your Moorpark location.',
      },
      {
        question: 'How much is mobile detailing in Moorpark?',
        answer:
          'Pricing starts at $160 for exterior, $180 for interior, and $300 for a full detail, with adjustments for vehicle size. Call (818) 381-9905 for a personalized quote.',
      },
      {
        question: 'Can you detail trucks and larger vehicles?',
        answer:
          'Absolutely. We regularly detail trucks, SUVs, and larger vehicles common in Moorpark. Pricing is adjusted for size \u2014 just let us know your vehicle when booking.',
      },
    ],
  },
  {
    slug: 'newbury-park',
    name: 'Newbury Park',
    keyword: 'Mobile Detailing Newbury Park',
    title: 'Mobile Car Detailing in Newbury Park, CA',
    subtitle:
      'Premium mobile detailing that comes to your home in Newbury Park. Showroom results for your vehicle without ever leaving your driveway.',
    metaDescription:
      'Top mobile detailing in Newbury Park, CA. Interior, exterior, full details, and ceramic protection at your door. Call Mike\u2019s Pro Detail at (818) 381-9905.',
    paragraphs: [
      "Newbury Park residents take pride in their vehicles, and Mike's Pro Detail helps keep them looking immaculate with mobile detailing delivered right to your door. From the hillside homes near Dos Vientos to the neighborhoods around Borchard and Wendy, we bring a complete detail shop to your driveway, so your car gets meticulous care without the hassle of a drop-off.",
      'Our Newbury Park detailing packages cover the full spectrum — interior deep cleans, exterior hand washes, and long-lasting ceramic protection. We use premium products and safe, scratch-free techniques to keep luxury and family vehicles alike in pristine condition, protected against the Conejo Valley sun and wind-blown dust.',
      'Convenience matters for busy Newbury Park families and professionals, which is why we operate fully mobile. We arrive with our own water and detailing equipment and handle everything on-site, letting you reclaim your time while we transform your vehicle. We require access to a standard electrical outlet at the service location. Choose a one-time detail or a recurring maintenance plan.',
    ],
    neighborhoods: [
      'Dos Vientos',
      'Borchard',
      'Casa Conejo',
      'Rancho Conejo',
      'Old Town Newbury Park',
    ],
    faqs: [
      {
        question: 'Do you serve all of Newbury Park?',
        answer:
          'Yes. We come to every Newbury Park neighborhood including Dos Vientos, Borchard, Casa Conejo, and Rancho Conejo. We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location.',
      },
      {
        question: 'Can you ceramic coat my car in Newbury Park?',
        answer:
          'Yes. We offer hybrid ceramic spray protection on-site in Newbury Park, applied after a thorough wash and clay bar decontamination for a clean, glossy finish that sheds water and dirt.',
      },
      {
        question: 'What does detailing cost in Newbury Park?',
        answer:
          'Exterior details start at $160, interior at $180, and full details at $300, with hybrid ceramic spray protection quoted separately. Call (818) 381-9905 for a quote.',
      },
      {
        question: 'How long does a detail take at my Newbury Park home?',
        answer:
          'A wash and wax takes about 1.5\u20132 hours, interior detailing 2\u20133 hours, and a full detail 3\u20134 hours. We take the time needed to deliver five-star results.',
      },
    ],
  },
  {
    slug: 'westlake-village',
    name: 'Westlake Village',
    keyword: 'Mobile Detailing Westlake Village',
    title: 'Mobile Car Detailing in Westlake Village, CA',
    subtitle:
      'Luxury mobile car detailing delivered to your home in Westlake Village. White-glove results for your vehicle, right in your driveway.',
    metaDescription:
      'Luxury mobile car detailing in Westlake Village, CA. Premium interior, exterior, full details, and hybrid ceramic spray protection at your door. Call (818) 381-9905.',
    paragraphs: [
      "Westlake Village is known for its luxury homes and high-end vehicles, and Mike's Pro Detail delivers the white-glove detailing those cars deserve — right at your door. From the lakeside estates to the gated communities throughout Westlake Village, we bring a complete, fully equipped detail shop to your driveway for a meticulous, hand-crafted finish.",
      'Our Westlake Village detailing service is built for luxury and performance vehicles that demand careful, scratch-free care. We offer hybrid ceramic spray protection, premium leather conditioning, and steam sanitizing — all using top-tier products and techniques designed to protect and enhance high-end finishes.',
      "For busy Westlake Village residents, our fully mobile service is the ultimate convenience. We arrive with our own water and detailing equipment and complete the detail on-site while you carry on with your day. We require access to a standard electrical outlet at the service location. Whether it's a single show-car detail or an ongoing maintenance plan, we keep your vehicle in concours condition.",
    ],
    neighborhoods: [
      'North Shore',
      'Three Springs',
      'Westlake Trails',
      'First Neighborhood',
      'The Landing',
    ],
    faqs: [
      {
        question: 'Do you detail luxury vehicles in Westlake Village?',
        answer:
          'Yes. We specialize in white-glove detailing for luxury, exotic, and performance vehicles throughout Westlake Village, including hybrid ceramic spray protection for premium finishes.',
      },
      {
        question: 'Can you come to gated and lakeside communities?',
        answer:
          'Absolutely. We serve all of Westlake Village including the lakeside estates and gated communities. Share any access details when booking and we\u2019ll coordinate entry.',
      },
      {
        question: 'What detailing packages are available in Westlake Village?',
        answer:
          'We offer exterior details from $160, interior from $180, full details from $300, plus hybrid ceramic spray protection quoted to your vehicle. Call (818) 381-9905.',
      },
      {
        question: 'Do you offer ongoing detailing plans?',
        answer:
          'Yes, many Westlake Village clients book recurring maintenance details to keep their vehicles in showroom condition year-round. We\u2019ll tailor a schedule to your needs.',
      },
    ],
  },
]
export function getCity(slug: string): CityData | undefined {
  return cities.find((c) => c.slug === slug)
}
export const CONTACT_PHONE = PHONE
